import { createFileRoute, Navigate } from '@tanstack/react-router'

export const Route = createFileRoute('/(redirects)/bak/contracts/$subscriptionId/endorsement/$endorsementId/')({
  component: () => (
    <Navigate
      replace
      search
      from="/bak/contracts/$subscriptionId/endorsement/$endorsementId/"
      to="/bo/contracts/$subscriptionId/endorsements/$endorsementId"
    />
  ),
})
